import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { SubstanceScreeningCollectionSite } from './substance-screening-collection-site';
import { SubstanceScreeningResult } from './substance-screening-result';
import { SubstanceScreeningStatus } from './substance-screening-status';

@inheritSerialization(AbstractModel)
export class SubstanceScreening extends AbstractModel {
  @autoserialize
  screeningId: number;

  @autoserialize
  driverId: number;

  @autoserializeAs(SubstanceScreeningCollectionSite)
  collectionSite: SubstanceScreeningCollectionSite;

  @autoserialize
  providerRegistrationId: number;

  @autoserializeAs(Date)
  reportedDate: Date;

  @autoserializeAs(Date)
  scheduledDate: Date;

  @autoserializeAs(Date)
  expirationDate: Date;

  @autoserialize
  reasonForTest: string;

  @autoserializeAs(SubstanceScreeningStatus)
  substanceScreeningStatuses: Array<SubstanceScreeningStatus>;

  @autoserializeAs(SubstanceScreeningResult)
  substanceScreeningResults: Array<SubstanceScreeningResult>;

  /**** Serialization ****/

  public static OnSerialized(instance: SubstanceScreening, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.reportedDate)) {
      json.reportedDate = DateUtil.serializeDate(instance.reportedDate);
    }
    if (!isNullOrUndefined(instance.scheduledDate)) {
      json.scheduledDate = DateUtil.serializeDate(instance.scheduledDate);
    }
    if (!isNullOrUndefined(instance.expirationDate)) {
      json.expirationDate = DateUtil.serializeDate(instance.expirationDate);
    }
  }

  public static OnDeserialized(instance: SubstanceScreening, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['reportedDate'])) {
      instance.reportedDate = DateUtil.deserializeDate(json['reportedDate']);
    }
    if (!isNullOrUndefined(json['scheduledDate'])) {
      instance.scheduledDate = DateUtil.deserializeDate(json['scheduledDate']);
    }
    if (!isNullOrUndefined(json['expirationDate'])) {
      instance.expirationDate = DateUtil.deserializeDate(json['expirationDate']);
    }
  }
}
